export class LoginRequestProto {
    userName: string;
    password: string;
}


export class CreateUserProto {
    firstName: string;
    lastName: string;
    emailId: string;
    mobileNo: string;
    countryCode: string;
    gender: string = '';
    password: string;
    address: Address;
    userId: string;
    streetAddress1: string;
    streetAddress2: string;
    city: string;
    state: string;
    country: string;
    pin: string;
    dateOfBirth: string;
}

export class Address {
    id: string;
    userId: string;
    alias: string;
    isPrimary: boolean;
    streetAddress1: string;
    streetAddress2: string;
    city: string;
    state: string;
    country: string;
    pin: string;
}
